<app-dialog [config]="config" (actionButtonClicked)="onFormSubmit($event)">
    <ng-container dialog-title>
        Assign Account
    </ng-container>

    <ng-container
        dialog-process-in-progress

        *ngIf="assignClientAccountRightsForm && assignClientAccountRightsForm.controls"

        [formGroup]="assignClientAccountRightsForm.form"
    >
        <div class="container-fluid">
            <div
                *ngIf="!assignClientAccountRightsForm.initForAccount"

                [ngClass]="{'mb-3': assignClientAccountRightsForm.controls.type.errors.length > 0}"
            >
                <app-radio-group
                    [formControlName]="assignClientAccountRightsForm.controls.type.name"
                    [control]="assignClientAccountRightsForm.controls.type"
                    (ngModelChange)="initForm($event)"
                ></app-radio-group>
            </div>
            <div [ngClass]="{'mb-3': assignClientAccountRightsForm.controls.selectableEntity.errors.length > 0}">
                <app-autocomplete
                    [formControlName]="assignClientAccountRightsForm.controls.selectableEntity.name"
                    [control]="assignClientAccountRightsForm.controls.selectableEntity"
                ></app-autocomplete>
            </div>

            <ng-container [formArrayName]="assignClientAccountRightsForm.assignClientAccountRightsArraySelector">
                <div
                    *ngFor="let control of assignClientAccountRightsForm.controls.rights; let i = index"

                    [ngClass]="{'mb-3': control.errors.length > 0}"
                >
                    <app-checkbox
                        [formControlName]="i"
                        [control]="control"
                    >
                        <ng-container text>{{control.placeholder}}</ng-container>
                    </app-checkbox>
                </div>
                <div *ngIf='assignClientAccountRightsForm.rightsErrors.length > 0' class="form-text text-danger mt-3">
                    <span *ngFor="let error of assignClientAccountRightsForm.rightsErrors">{{error}}</span>
                </div>
            </ng-container>
        </div>
    </ng-container>
</app-dialog>
